
import React from "react";

function Error403(props) {
    return (
        <>
            <div className="content text-right" style={{direction:'rtl',backgroundColor: '#e7eaf1',paddingBottom:'60px'}}>
                <div style={{paddingTop:'80px'}}></div>
    <div className="row col-md-12">
        <div className="col-md-6" style={{backgroundImage:require('../assets/img/deny.png').default}}>

               {(props.location.state && props.location.state!=null)?
                           <div className="landing-page" style={{margin:'0px 60px 40px 40px'}}>
                           <h3>کاربر گرامی</h3>
            <span style={{textAlign:'center',fontSize:'23px',color:'red',marginBottom:'25px',fontWeight:'bolder'}}>{props.location.state.title}</span>
            <span style={{textAlign:'center',fontSize:'18px',color:'blue',marginBottom:'15px',fontWeight:'bolder'}}>{props.location.state.text}</span>
            </div>
            :""}
  
        </div>
        <div className="col-md-6">
            <img alt=" Not load" src={require("../assets/img/deny.png").default}></img>
        </div>
    </div>
</div>
        </>
    );
}

export default Error403;
